<template lang="pug">
  .parallax
</template>

<script>
export default {
  props: ['theUrl', 'theHeight', 'textColor'],
  data() {
    return {
      thestyle: {
        'background-image': `url(${this.theUrl})`,
        height: `${this.theHeight}`,
        'background-attachment': 'fixed',
        'background-position': 'top',
        'background-repeat': 'no-repeat',
        'background-size': 'cover',
        color: `${this.textColor}`
      }
    };
  }
};
</script>

<style lang="stylus" scoped>
.parallax
  background-image url('../assets/img/4255632_orig.png')
  height 300px
  background-attachment fixed
  background-position top
  background-repeat no-repeat
  background-size 100% 500px
  color white
</style>
